import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-urbanisme',
  templateUrl: './urbanisme.component.html',
  styleUrls: ['./urbanisme.component.scss']
})
export class UrbanismeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
